import { TypeInitProps, TypeRequest } from '../../../types';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class ResourceAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  getResourceList = (params: {
    page?: number;
    page_size?: number;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const { page = 1, page_size = 10, subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: `${WEB_AFF_URL.RESOURCE_LIST}${page}/`,
        method: 'GET',
        data: {
          page_size,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };
}
